import styled from "styled-components";

export const AppHeader = styled.header`
    background-color: var(--color-background);
    padding: 2rem 1.5rem;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 200;

    & .logo {
        width: 5rem;
        height: 5rem;
        cursor: pointer;
        -webkit-clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
        clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
    }

    & a {
        display: block;
        width: 100%;
        text-align: center;
        -webkit-clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
        clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
    }

    & svg {
        display: inline-block;
        width: 4rem;
        height: 4rem;
        border: 5px solid transparent;
    }

    & .menu-icon {
        width: 4rem;
        height: 4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 50%;
        transition: all .3s ease;

        &::after {
            border-radius: 50%;
        }
    }

    & .menu-icon span {
        display: block;
        height: 2px;
        width: 16px;
        background-color: var(--color-text);
        border-radius: 10px;
        position: relative;
    }

    & .menu-icon span::before,
    & .menu-icon span::after {
        content: '';
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--color-text);
    }

    & .menu-icon span::before {
        top: -6px;
    }

    & .menu-icon span::after {
        top: 6px;
    }
`;